import React from 'react';
import '../Styles/AboutPage.css';
//import Lottie from 'lottie-react';
//import anime1 from '../animations/anime5.json';

const AboutUs = () => {
    return (
        <div className="about-container">
            {/* Hero
            <section className="about-hero">
                <div className="overlay"></div>
                <div className="about-hero-content">
                    <Lottie animationData={anime1} loop={true} className="about-animation"
                            style={{width: '75%', height: '75%'}}/>

                </div>
            </section>*/}

            {/* Content Sections */}
            <section className="about-section">
                <div className="about-content">
                    <h2 >Hakkımızda</h2>
                    <p>
                        MeduVR, hedef gruplara yönelik simülasyonlar ve VR teknolojisi ile geliştirilmiş içerikler içeren Türkiye’nin ilk ve tek sanal gerçeklik tabanlı eğitim uygulamasıdır. Bu uygulama, "Tıbbi Görüntüleme Teknikleri programı öğrencilerine", "sağlık profesyonellerine", "üniversite öğrencilerine", "topluma" ve "tıbbi görüntüleme cihaz profesyonellerine" yönelik kapsamlı eğitim içerikleri sunmaktadır. Eğitim çözüm ortaklarıyla geliştirilen programlar sayesinde sektöre yeni bir bakış açısı ve derinlik kazandırmayı amaçlayan MeduVR, 2018 yılı sonunda Türkiye’nin en dikkat çeken yenilikçi eğitim, bilgilendirme ve farkındalık programı haline gelmiştir. MeduVR, sanal gerçeklik teknolojisiyle tıbbi görüntüleme eğitiminde devrim yaratmayı ve kullanıcılarına pratik, etkileşimli bir öğrenme deneyimi sunmayı hedeflemektedir.
                    </p>

                    <h2>Tarihçe</h2>
                    <p>
                        Türkiye’nin ilk ve tek sanal gerçeklik tabanlı eğitim uygulaması olarak düşünülen girişimin çalışmaları, Doç. Dr. Nuran Akyurt tarafından 2018 yılında başlatılmıştır. Bilimsel Araştırma Projeleri Birimi (BABKO) tarafından desteklenen "Tıbbi Görüntüleme Teknikleri Eğitiminde Sanal Gerçeklik" projesi, Doç. Dr. Nuran Akyurt'un yürütücülüğünde ilk çalışmalarına başlamıştır. 2020 yılında Bayer’in G4A Turkey programından aldığı destekle projelerini genişleten Doç. Dr. Nuran Akyurt, 2021 yılında RSG Bilgi Teknolojileri Sağlık ve İnovasyon Ltd. Şti.’nin kurucu ortağı ve genel müdürü olarak Teknopark'ta AR-GE projeleri geliştirme faaliyetlerine devam etmiştir. Aynı yıl, Sanayi Bakanlığı'na projeler hazırlayarak sektörün ihtiyaçlarına yönelik yenilikçi çözümler üretmeye başlamıştır. KOSGEB İleri Girişimci Destek Programı tarafından 2022 yılında aldığı destekle kadın girişimciliğini teşvik etmeye yönelik projeler geliştirmiştir. 2023 yılında, Doç. Dr. Nuran Akyurt’un proje yürütücülüğünü yaptığı, Cumhurbaşkanlığı Strateji ve Bütçe Başkanlığı ile Yükseköğretim Kurulu Başkanlığı’nın Araştırma Üniversiteleri Destek Programı (ADEP) kapsamında "Sanal Gerçeklik Teknolojisi VR ile Meme Kanseri Erken Tanı ve Tarama Prototipinin Geliştirilmesi" projesi yatırım desteği alarak bu alanda önemli adımlar atmıştır. Bu projeler, kadınlara meme kanseri tanı-tarama yöntemleri konusunda deneyim kazandırarak farkındalık sağlamayı amaçlamaktadır.
                    </p>

                    <h2>Öne Çıkan Özelliklerimiz</h2>
                    <ul>
                        <li>Türkiye’nin ilk ve tek sanal gerçeklik tabanlı eğitim uygulaması</li>
                        <li>Tıbbi Görüntüleme Teknikleri programı öğrencileri, sağlık profesyonelleri, üniversite
                            öğrencileri, toplum ve tıbbi görüntüleme cihaz profesyonellerine yönelik kapsamlı eğitim
                            içerikleri
                        </li>
                        <li>Eğitim çözüm ortaklarıyla geliştirilen yenilikçi programlar</li>
                        <li>Sanal gerçeklik teknolojisiyle pratik ve etkileşimli öğrenme deneyimi</li>

                        <li>Kadın girişimciliğini destekleyen ve teşvik eden projeler</li>

                        <li>AR-GE ve inovasyon alanında öncü çalışmalar</li>

                        <li>Teknopark'ta yer alma ve Sanayi Bakanlığı'na projeler hazırlama kapasitesi</li>
                        <li>Kadınlara meme kanseri tanı-tarama yöntemleri konusunda deneyim kazandırma ve farkındalık sağlama</li>
                        <li>Simülasyonlar ve VR teknolojisi ile geliştirilmiş içerikler</li>


                    </ul>
                </div>
            </section>
        </div>
    );
};

export default AboutUs;